export const rejectNotHandled = (v: never): never => {
  throw new Error(`not handled: "${v as string}"`);
};
